import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

export const getBundlesSuggestions = ({ ids, limit }: { ids: number[]; limit: number }) =>
    axios.post(`${API_URLS.BUNDLE_SUGGESTIONS}`, { ids, limit });
